import type { SwitchProps as AntdSwitchProps } from "antd";
import { Switch as AntdSwitch } from "antd";
import React from "react";

export interface SwitchProps extends AntdSwitchProps {
  ariaDescribedby?: string; // Link to additional help text
  ariaLabel?: string; // Accessible label for screen readers
}
const Switch: React.FC<SwitchProps> = ({
  ariaLabel,
  ariaDescribedby,
  ...rest
}) => {
  return (
    <AntdSwitch
      aria-describedby={ariaDescribedby} // Link to help text
      aria-label={ariaLabel} // Accessible label
      {...rest}
    />
  );
};

export default Switch;
